import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PhoneFilledSvg from "@ant-design/icons-svg/es/asn/PhoneFilled";
import AntdIcon from "../components/AntdIcon";
var PhoneFilled = function PhoneFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PhoneFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PhoneFilled.displayName = 'PhoneFilled';
}
export default /*#__PURE__*/React.forwardRef(PhoneFilled);